<template>

  <ion-page id="legacy-rep-manager-page">
    <ion-content>
        <LegacyRepManager :descriptionHeading="descriptionHeadingString"/>
    </ion-content>
  </ion-page>
</template>

<script setup>

  import { IonItem, IonList, IonButton, IonRange,IonPage, IonContent, modalController } from '@ionic/vue';

  import LegacyRepManager from '@/components/LegacyRepManager.vue'
  import Toolbar from '@/components/Toolbar.vue'
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
  import { t } from '@/composables/translateText.js'

  import { ref, watch } from 'vue'
  import { onMounted, onBeforeMount } from 'vue'

  import { useConnectionStore } from '@/stores/connectionStore';
  import { useGetData } from '@/composables/getData.js'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { availableWidthHeight } from '@/composables/screenSize'

  const toolbarTrigger = ref(0)

  const connectionStore = useConnectionStore()

  const descriptionHeadingString = ref(t('Repertoire Manager'))
  
  const isDark = ref(connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  const styleOneFrame = ref({
     position : "absolute",
     "overflow-y" : "scroll",
     top : "0px",
     left : "100px",
     width: "100px",
     height : "100px"
   })

  function afterStartupCallbackRoutine(stuffChanged) {
    if (connectionStore.getIsSubscriber != 1) {
      return
    }
    menuTrigger.value++
  }

  updateWidthHeights()

  doStartupCheck(false,afterStartupCallbackRoutine)

  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** Explorer -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** Explorer new window size",windowSizeRef.value)
    updateWidthHeights()
    menuTrigger.value++
  })

  function updateWidthHeights() {
  
    const availableSpace = availableWidthHeight()
    const oneframePositionTop = availableSpace.topIndent
    const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
    const oneframeHeight = availableSpace.height - oneframePositionTop + availableSpace.topIndent
    const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    styleOneFrame.value.height = oneframeHeight + "px"
    styleOneFrame.value.width = oneframeWidth + "px"
    styleOneFrame.value.top = oneframePositionTop + "px"
    styleOneFrame.value.left = oneframePositionLeft + "px"
  }

</script>

<style scoped>

</style>